import {defineMessages} from 'react-intl.macro';

export const messages = defineMessages({
  'checkpoint.form.createIdentity': {
    defaultMessage: 'Create proof of presence identity',
    id: 'checkpoint.form.createIdentity'
  },
  'checkpoint.form.description': {
    defaultMessage: 'Description',
    id: 'checkpoint.form.description'
  },
  'checkpoint.form.generateIdentity': {
    defaultMessage: 'Generate identity',
    id: 'checkpoint.form.generateIdentity'
  },
  'checkpoint.form.identity': {
    defaultMessage: 'Proof of presence identity',
    id: 'checkpoint.form.identity'
  },
  'checkpoint.form.name': {
    defaultMessage: 'Name',
    id: 'checkpoint.form.name'
  },
  'checkpoint.form.noProofOfPresence': {
    defaultMessage: 'No proof of presence',
    id: 'checkpoint.form.noProofOfPresence'
  },
  'checkpoint.form.order': {
    defaultMessage: 'Visit Order',
    id: 'checkpoint.form.order'
  },
  'checkpoint.form.proofOfPresence': {
    defaultMessage: 'Proof of presence',
    id: 'checkpoint.form.proofOfPresence'
  }
});
